import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '@shared';
import { CandidateExtraInfoService } from '@shared/services/candidate-extra-info.service';
import { CandidateExtraInfoComponent } from '@modules/candidate-extra-info/components/candidate-extra-info.component';
import { CandidateExtraInfoEffects } from '@modules/candidate-extra-info/store/candidate-extra-info.effects';
import { candidateExtraInfoReducer } from '@modules/candidate-extra-info/store/candidate-extra-info.reducer';
import { MatIconModule } from '@angular/material/icon';
import { FeatureFlagsModule } from 'mojo-feature-flags';

@NgModule({
  declarations: [CandidateExtraInfoComponent],
  imports: [
    CommonModule,
    StoreModule.forFeature('candidateExtraInfo', candidateExtraInfoReducer),
    EffectsModule.forFeature([CandidateExtraInfoEffects]),
    SharedModule,
    MatIconModule,
    FeatureFlagsModule,
  ],
  providers: [CandidateExtraInfoService],
  exports: [CandidateExtraInfoComponent],
})
export class CandidateExtraInfoModule {}
